import type { LinkObject } from 'bundles/ent-website/contentful/core/Navigation';

/**
 * Returns true if empty string or undefined
 */
export const isEmptyLink = (link: LinkObject): boolean => {
  // Can be undefined or empty string
  // Empty string considered an empty link
  return (link?.href ?? '')?.length === 0;
};
